export default {
  bagFees: 'Er kunnen extra bagagekosten in rekening worden gebracht',
}
